import { Injectable } from '@angular/core';
import { environment as env } from '../../../../environments/environment';
import { SELECT_SCHEMA_COLLECTIONS } from './select-schema-collection.constants';

export interface ActiveSchemaConfig<T = any> {
  apiUrl: string;
  moduleName: string;
  defaultSort: keyof T | string;
  searchFields: (keyof T | string)[];
}
@Injectable({ providedIn: 'root' })
export class SchemaServiceResolver {
  private configMap = new Map<string, ActiveSchemaConfig>();

  constructor() {
    this.register();
  }

  private register() {
    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.MATERIAL, {
      apiUrl: env.API_MATERIAL_URL,
      moduleName: 'material',
      defaultSort: '_id',
      searchFields: ['code', 'name', 'externalKeys.code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.BUSINESS_PARTNER, {
      apiUrl: env.API_BUSINESS_PARTNER_URL,
      moduleName: 'business-partner',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.COMPANY, {
      apiUrl: env.API_CONFIGURATION_URL,
      moduleName: 'company',
      defaultSort: '_id',
      searchFields: ['name', 'NIT'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.PAYMENT_CONDITION, {
      apiUrl: env.API_UNIT_MEASURE,
      moduleName: 'payment_condition',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.CURRENCY, {
      apiUrl: env.API_UNIT_MEASURE,
      moduleName: 'currency',
      defaultSort: '_id',
      searchFields: ['name', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.REQUIREMENT, {
      apiUrl: env.API_UNIT_MEASURE,
      moduleName: 'requirement',
      defaultSort: '_id',
      searchFields: ['name'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.UNIT_MEASUREMENT, {
      apiUrl: env.API_UNIT_MEASURE,
      moduleName: 'unit_measurement',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.PRICE_LIST, {
      apiUrl: env.API_UNIT_MEASURE,
      moduleName: 'price_list',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.EXPEDITION_CONDITION, {
      apiUrl: env.API_UNIT_MEASURE,
      moduleName: 'expedition_condition',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.REASON_REJECTION, {
      apiUrl: env.API_UNIT_MEASURE,
      moduleName: 'reason_rejection',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.REASON_REJECTION_TYPE, {
      apiUrl: env.API_UNIT_MEASURE,
      moduleName: 'reason_rejection_types',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.BAD_CONDITION, {
      apiUrl: env.API_UNIT_MEASURE,
      moduleName: 'bad_condition',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.REASON_VISIT, {
      apiUrl: env.API_UNIT_MEASURE,
      moduleName: 'reason_visit',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.MOTIVE_BLOCK, {
      apiUrl: env.API_UNIT_MEASURE,
      moduleName: 'motive_block',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.BANKS, {
      apiUrl: env.API_PAYMENT_MASTER_URL,
      moduleName: 'banks',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.CHANGE_CONDITION, {
      apiUrl: env.API_AVE_RETURN,
      moduleName: 'return-type',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.LOCATION_ONE, {
      apiUrl: env.API_LOCATION_URL,
      moduleName: 'location_one',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.LOCATION_TWO, {
      apiUrl: env.API_LOCATION_URL,
      moduleName: 'location_two',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.LOCATION_THREE, {
      apiUrl: env.API_LOCATION_URL,
      moduleName: 'location_three',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.LOCATION_FOUR, {
      apiUrl: env.API_LOCATION_URL,
      moduleName: 'location_four',
      defaultSort: '_id',
      searchFields: ['name', 'externalKeys.code', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.BUSINESS_PARTNER_GROUP, {
      apiUrl: env.API_BUSINESS_PARTNER_URL,
      moduleName: 'BusinessPartnerGroup',
      defaultSort: '_id',
      searchFields: ['name'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.BUSINESS_PARTNER_SUB_GROUP, {
      apiUrl: env.API_BUSINESS_PARTNER_URL,
      moduleName: 'business_partner_subgroup',
      defaultSort: '_id',
      searchFields: ['name'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.BUSINESS_PARTNER_FUNCTION, {
      apiUrl: env.API_BUSINESS_PARTNER_URL,
      moduleName: 'business-partner-function',
      defaultSort: '_id',
      searchFields: ['name', 'code'],
    });

    this.configMap.set(SELECT_SCHEMA_COLLECTIONS.IDENTITY_DOCUMENT_TYPE, {
      apiUrl: env.API_UNIT_MEASURE,
      moduleName: 'identity_document_type',
      defaultSort: '_id',
      searchFields: ['name', 'code'],
    });
  }

  // Devuelve null si el schema no esta registrado, para no romper al consumidor
  resolve(schema: string): ActiveSchemaConfig | null {
    return this.configMap.get(schema) ?? null;
  }
}
